import React from 'react';
import GradesWithGpa1 from '../../../assets/img/award/grades-gpa-1.png';
import GradesWithGpa2 from '../../../assets/img/award/grades-gpa-2.png';
import SampleImagePage from './sample-image-page';

const styles = {
  card: 'w-[60%] self-stretch pl-10 pt-2 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-brand-cyan inline-flex flex-col justify-start items-start',
  title: 'justify-start text-blue text-3xl font-normal font-serif leading-10',
  introSection: 'w-[90%] self-stretch text-xl items-center',
  introSectionTitle: 'text-xl mb-2',
  imageStyle: 'outline outline-1 outline-offset-[-0.2px] outline-gray',
};

const GradesWithGpaSample = () => {
  return (
    <SampleImagePage
      cardClassName={styles.card}
      titleClassName={styles.title}
      sectionClassName={styles.introSection}
      sectionTitleClassName={styles.introSectionTitle}
      items={[
        {
          title: 'Sample One',
          src: GradesWithGpa1,
          alt: 'Grades With GPA Sample 1',
          width: '90%',
          imageWrapperClassName: `${styles.imageStyle} mb-4`,
        },
        {
          title: 'Sample Two',
          src: GradesWithGpa2,
          alt: 'Grades With GPA Sample 2',
          width: '100%',
          imageWrapperClassName: `${styles.imageStyle} mb-2`,
        },
      ]}
    />
  );
};

export default GradesWithGpaSample;
